import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  useMediaQuery,
} from "@mui/material";
import React from "react";

const StockHistoryTable = ({ items }) => {
  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down("md"));
  return (
    <Box
      sx={{ backgroundColor: "#e7ebf0", borderRadius: 2, flex: 1 }}
      padding={1}
    >
      <TableContainer component={Paper}>
        <Table aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell sx={{ minWidth: 150 }}>
                {isSmallScreen ? "Name" : "Product name"}
              </TableCell>
              <TableCell align="center" sx={{ minWidth: 120 }}>
                Price
              </TableCell>
              <TableCell align="center">Qty</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {items.map((item) => (
              <TableRow
                key={item.id}
                sx={{
                  "&:last-child td, &:last-child th": { border: 0 },
                }}
              >
                <TableCell component="th" scope="row">
                  {item.name}
                </TableCell>
                <TableCell align="center">{item.price} Rs</TableCell>
                <TableCell align="center">{item.current_qty} Nos</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default StockHistoryTable;
